import angular from 'angular';
import { Instructions } from './instructions.component';
import { instructionComponents } from './components/instructionConfiguration';
import { ModelConfiguration } from './modelConfiguration/modelConfiguration.component';
import { PromptInput } from './promptInput/promptInput.component';
import { AdvancedInstructionComponent } from './advancedInstruction/advancedInstruction.component';
import { GuardRailComponent } from './guardRail/guardrail.component';
export const instructionsTabModule = angular
    .module('aiAgentInstructionsTabModule', [instructionComponents])
    .component('instructionsTab', Instructions)
    .component('modelConfiguration', ModelConfiguration)
    .component('promptInput', PromptInput)
    .component('advancedInstruction', AdvancedInstructionComponent)
    .component('guardrail', GuardRailComponent)
    .name;
